import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import MissionVision from "../components/MissionVision";
import Programs from "../components/Programs";
import CoreValues from "../components/CoreValues";
import VisionHub from "../components/VisionHub";
import Partners from "../components/Partners";
import GetInvolved from "../components/GetInvolved";
import Newsletter from "../components/Newsletter";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <main className="bg-[#F4F1EB] text-[#2C2A29] font-sans" data-testid="landing-page">
      <Header />
      <Hero />
      <About />
      <MissionVision />
      <Programs />
      <CoreValues />
      <VisionHub />
      <Partners />
      <GetInvolved />
      <Newsletter />
      <Contact />
      <Footer />
    </main>
  );
}
